import {ActivatedRoute} from '@angular/router';
import {WizardPageBaseComponent} from '@utils-lib';
import {Component} from '@angular/core';
import {ZustandigkeitsvereinbarungAngaben} from '@nachdigal';

@Component({
  selector: 'kapg-aus-lib-zustandigkeitsvereinbarung-angaben',
  templateUrl: './zustandigkeitsvereinbarung-angaben.component.html'
})
export class ZustandigkeitsvereinbarungAngabenComponent extends WizardPageBaseComponent<ZustandigkeitsvereinbarungAngaben> {

  static nutzdatenPath = 'zustandigkeitsvereinbarungAngaben';
  static route = 'zustandigkeitsvereinbarung-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }

}
